/**
 * Enum for user abilities in the system
 * This matches the Java UserAbility enum in com.medprompt.identity.perms.UserAbility
 */
export const UserAbility = {
  DOCS_READ: {
    key: 'DOCS_READ',
    displayName: 'View Documents',
    description: 'Ability to view patient documents'
  },
  DOCS_READ_ALL: {
    key: 'DOCS_READ_ALL',
    displayName: 'View All Documents',
    description: 'Ability to view all patient documents across the system'
  },
  DOCS_WRITE: {
    key: 'DOCS_WRITE',
    displayName: 'Edit Documents',
    description: 'Ability to edit and modify patient documents'
  },
  CLINIC_DATA_READ: {
    key: 'CLINIC_DATA_READ',
    displayName: 'View Clinic Data',
    description: 'Ability to view clinic information'
  },
  INSIGHTS_READ: {
    key: 'INSIGHTS_READ',
    displayName: 'View Insights',
    description: 'Ability to view insights and analytics'
  },
  INSIGHTS_READ_ALL: {
    key: 'INSIGHTS_READ_ALL',
    displayName: 'View All Insights',
    description: 'Ability to view user-specific insights'
  },
  CONFIG_READ: {
    key: 'CONFIG_READ',
    displayName: 'View Configuration',
    description: 'Ability to view system configuration'
  },
  CONFIG_WRITE: {
    key: 'CONFIG_WRITE',
    displayName: 'Edit Configuration',
    description: 'Ability to modify system configuration'
  },
  PERMS_READ: {
    key: 'PERMS_READ',
    displayName: 'View Permissions',
    description: 'Ability to view user permissions and roles'
  },
  PERMS_WRITE: {
    key: 'PERMS_WRITE',
    displayName: 'Edit Permissions',
    description: 'Ability to modify user permissions and roles'
  },
  MASTER_READ: {
    key: 'MASTER_READ',
    displayName: 'Master Read Access',
    description: 'Master-level read access to all system resources'
  },
  MASTER_WRITE: {
    key: 'MASTER_WRITE',
    displayName: 'Master Write Access',
    description: 'Master-level write access to all system resources'
  },
  CONSULT_READ: {
    key: 'CONSULT_READ',
    displayName: 'View Consultations',
    description: 'Ability to view assigned and archived consultations'
  },
  CONSULT_READ_ALL: {
    key: 'CONSULT_READ_ALL',
    displayName: 'View All Consultations',
    description: 'Ability to view all active consultations across the system'
  },
  CONSULT_WRITE: {
    key: 'CONSULT_WRITE',
    displayName: 'Edit Consultations',
    description: 'Ability to create, edit, and delete consultations'
  },
  TASK_READ: {
    key: 'TASK_READ',
    displayName: 'View Tasks',
    description: 'Ability to view outcome tasks'
  },
  TASK_WRITE: {
    key: 'TASK_WRITE',
    displayName: 'Edit Tasks',
    description: 'Ability to edit, complete, and delete outcome tasks'
  }
};
